import React from 'react';
import { connect } from 'redux-bundler-react';

class AddDataTooLarge extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      content: 'Fetching Information',
    }
    this.accept = this.accept.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  
  accept() {
    const { handleAccept} = this.props;
    handleAccept();
  }
  cancel() {
    const { handleCancel } = this.props;
    handleCancel();
  }

  

  render(){
    const { content } = this.state;
    const { theme, fileSize} = this.props;
    
    return (
      <div>
        <div className={"modal-header " + theme}>
          Large File Size
        </div>
        <div
          className="modal-body thin-scrollbar"
          style={{ height: (window.innerHeight * 0.75), top: 0, bottom: 0, left: 0, right: 0, overflow: 'auto'}}
          
        >
          The added file  has size that is larger than what the browser can handle before experiencing performance issues.
          <br/>
          Current file size ({fileSize})
          <br/>
          Safe File Size 20mb
          <br />
          Do you want to continue loading this file?
        </div>
        <div className="modal-footer">
        <button className={"btn btn-theme " + theme} onClick={this.accept}>
            Accept
          </button>
          <button className={"btn btn-theme " + theme} onClick={this.cancel}>
            Cancel
          </button>
        </div>
      </div>
    )
  }
}

export default connect(
  'selectTheme',
  AddDataTooLarge
);